import { useState } from 'react';
import '../styles/ContactUs.css';

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    if (!formData.name || !formData.email || !formData.subject || !formData.message) {
      alert('Please fill in all required fields.');
      return;
    }

    const mailtoLink = `mailto:help@oliveeb.com?subject=${encodeURIComponent(formData.subject)}&body=${encodeURIComponent(
      `Name: ${formData.name}\nEmail: ${formData.email}\nPhone: ${formData.phone}\n\nMessage:\n${formData.message}`
    )}`;

    const confirmSend = confirm("Your message is ready. Click OK to open your email client and send, or Cancel to close.");
    if (confirmSend) {
      window.location.href = mailtoLink;
    }
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.id]: e.target.value
    });
  };

  return (
    <>
      <div className="contact-hero">
        <h1>Get in <span>Touch</span></h1>
        <p>Have questions, feedback, or need support? Our team is here to help you.</p>
      </div>

      <div className="contact-container">
        <div className="contact-grid">
          <div className="contact-info">
            <h2>Contact Information</h2>

            <div className="info-card">
              <div className="info-icon">📧</div>
              <div className="info-content">
                <h3>Email Us</h3>
                <p>For all inquiries:<br /><a href="mailto:help@oliveeb.com">help@oliveeb.com</a></p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">📞</div>
              <div className="info-content">
                <h3>Call Us</h3>
                <p>Customer support:<br /><a href="tel:+1234567890">+1 (234) 567-8900</a></p>
                <p style={{ marginTop: '8px' }}>Available Mon-Fri, 9am-6pm EST</p>
              </div>
            </div>

            <div className="info-card">
              <div className="info-icon">💬</div>
              <div className="info-content">
                <h3>Live Chat</h3>
                <p>Chat with a support agent directly in the app or on our website.<br />Available 24/7.</p>
              </div>
            </div>

            <div className="social-links-large">
              <a href="#" className="social-icon-large" aria-label="Facebook">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/>
                </svg>
              </a>
              <a href="#" className="social-icon-large" aria-label="X (Twitter)">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                </svg>
              </a>
              <a href="#" className="social-icon-large" aria-label="Instagram">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <rect x="2" y="2" width="20" height="20" rx="5" ry="5"/>
                  <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"/>
                  <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"/>
                </svg>
              </a>
              <a href="#" className="social-icon-large" aria-label="LinkedIn">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"/>
                  <rect x="2" y="9" width="4" height="12"/>
                  <circle cx="4" cy="4" r="2"/>
                </svg>
              </a>
            </div>
          </div>

          <div className="contact-form-card">
            <h2>Send us a message</h2>
            <p>We'll get back to you within 24 hours.</p>

            <form id="contactForm" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Full Name *</label>
                <input type="text" id="name" name="name" required placeholder="John Doe" value={formData.name} onChange={handleChange} />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email Address *</label>
                <input type="email" id="email" name="email" required placeholder="john@example.com" value={formData.email} onChange={handleChange} />
              </div>

              <div className="form-group">
                <label htmlFor="phone">Phone Number (optional)</label>
                <input type="tel" id="phone" name="phone" placeholder="+1 234 567 8900" value={formData.phone} onChange={handleChange} />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject *</label>
                <input type="text" id="subject" name="subject" required placeholder="How can we help?" value={formData.subject} onChange={handleChange} />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message *</label>
                <textarea id="message" name="message" required placeholder="Please describe your question or issue in detail..." value={formData.message} onChange={handleChange}></textarea>
              </div>

              <button type="submit" className="submit-btn">Send Message</button>
            </form>
            <p style={{ fontSize: '12px', color: 'var(--text-secondary)', marginTop: '16px', textAlign: 'center' }}>
              By submitting, you agree to our <a href="/privacy-policy.html" style={{ color: 'var(--primary)' }}>Privacy Policy</a>.
            </p>
          </div>
        </div>

        <div className="faq-link">
          <p>📖 Find quick answers in our <a href="/FAQs.html">Frequently Asked Questions</a> page.</p>
        </div>
      </div>
    </>
  );
};

export default ContactUs;